export const BranchTypeEnum = {
  HEADQUARTER: "headquarter",
  BRANCH: "branch",
} as const;

export type IBranchTypeEnum =
  (typeof BranchTypeEnum)[keyof typeof BranchTypeEnum];
